import getLinkHref from '@/modules/utils/api/getLinkHref'
import clientHTTP from '@/modules/clientHTTP'

const getSelections = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'selections'), params)
}

const createSelection = (application, params = {}) => {
  return clientHTTP.post(getLinkHref(application, 'selections'), params)
}

const deleteSelection = (selection) => {
  return clientHTTP.delete(getLinkHref(selection, 'self'))
}

export default {
  getSelections,
  createSelection,
  deleteSelection
}
